import type { SyncKeyValueStore } from "./sqlite-kv-store";

/**
 * Web never uses the SQLite-backed store (localStorage handles persistence),
 * so this platform variant keeps expo-sqlite and its wasm out of the web bundle.
 */
export const loadSqliteKeyValueStore = (): SyncKeyValueStore | undefined =>
	undefined;
